import BaseApi from './base'
import config from '../../config.json'
import queryString from 'query-string'

export default class LessonsApi extends BaseApi {
  constructor() {
    super()
  }

  getLesson(id) {
    return this.axios
      .get(`${config.apiUrl}/lessons/${id}`)
      .then(({ data }) => data)
  }

  /**
   * Posts a new understood status for the given lesson ID.
   * @param {number} status
   * @param {number} lessonId
   * @returns {Promise<AxiosResponse<T>>}
   */
  setUnderstood(status, lessonId) {
    let query = {
      lessonId,
      status,
    }

    return this.axios
      .post(
        `${config.apiUrl}/lessons/understood/`,
        queryString.stringify(query)
      )
      .then(({ data }) => {
        return data
      })
  }
}
